import defaultImg from '../../assets/img/default.png';
export const stringToImageBase64 = (res: string | undefined) => {
  return res ? 'data:image/png;base64,' + res : defaultImg;
};

export const imageBase64WithoutPrefix = (res: string | undefined) => {
  return res?.substring(res.indexOf(',') + 1);
};
